import React from 'react';

import './WorkWithUs.sass';

import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';

import {setBackground} from '../../ducks/ui';

import Meta from '../../components/meta/Meta';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import FeatureText from '../../components/featureText/FeatureText';
import JSONLDBoosthive from '../../components/JSON-LD/JSONLDBoosthive';

import work1 from './assets/work1.svg';
import work2 from './assets/work2.svg';
import work3 from './assets/work3.svg';
import work4 from './assets/work4.svg';
import WorkWithUsItem from "./WorkWithUsItem";

const textData = [
    {
        img: work1,
        header: 'Booster',
        text: 'Also we are actively recruiting for the Helldivers 2 (PC/PS), Last Epoch, PoE (PC/PS), Destiny 2 (PC/XBOX/PS). \n' +
            'Boosters are one of the key positions in our business. \n' +
            'The better your work, the more orders you will receive. Responsibility, professionalism, and motivation are what describe the ideal candidate for this position. If you think that this describes you, then we look forward to your application.\n'
    },
    {
        img: work2,
        header: 'WoW Booster',
        text: 'We are always delighted to welcome experienced World of Warcraft players to our team. If you\'re passionate about helping thousands of others enjoy World of Warcraft, driven to transform your favorite game into your dream job, and consider yourself a professional player, don\'t hesitate to apply for this role.\n',
        hiring: ['RBG teams with 2400+ experience on EU and US realms', 'Mythic + teams which playing at nights', 'Mythic raiding groups on EU and US realms', 'Any other players with unique abilities'],
    },
    {
        img: work3,
        header: 'Diablo IV Booster',
        text: 'We are always delighted to welcome experienced Diablo IV players to our team. If you\'re passionate about helping thousands of others enjoy Diablo, driven to transform your favorite game into your dream job, and consider yourself a professional player, don\'t hesitate to apply for this role.',
        hiring: ['High-skilled players who could farm 100+ GR with selfplayed customers', 'Searching for US-region boosters on Softcore and Hardcore', 'Boosters on PS4 and X-box', 'Hardcore TOP players']
    },
    {
        img: work4,
        header: 'WoW Classic Booster',
        text: 'We are always delighted to welcome experienced World of Warcraft: Classic (WOTLK, SOD) players to our team. If you\'re passionate about helping thousands of others enjoy World of Warcraft, driven to transform your favorite game into your dream job, and consider yourself \n' +
            'a professional player, don\'t hesitate to apply for this role.',
        hiring: ['1-60 levelers & Raid groups', '5 ppl groups', 'PvP players to farm Honor Rank', 'Gold Sellers']
    }
]

@injectIntl
@connect()
export default class WorkWithUsPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.childRefs = Array.from({ length: 4 }, () => React.createRef());
    }
  componentDidMount() {
    const {dispatch} = this.props;
      dispatch(setBackground());
    }
    scrollToChild = (index) => {
        this.childRefs[index].current.scrollIntoView({ behavior: 'smooth' });
    };
    render() {

      const {intl} = this.props

        return (
          <React.Fragment>
            <Meta
              title='Jobs for gamers at Boosthive | Earn money by playing games!'
              description='Boosthive offers the best way to earn money for gamers! Join our gamers community and start making money by playing, trading and farming in your favorite games!'
              alternateSlug="work-with-us"
            />

            <JSONLDBoosthive />

            <div className="page-work">
              <Breadcrumbs links={[{name: intl.formatMessage({id: 'section.generic.work'})}]}/>

              <FeatureText
                  headerComponent="h1"
                  header={intl.formatMessage({id: 'section.work.header'})}
                  text={intl.formatMessage({id: 'section.work.top-text'})}
                  />
                <div className='page-work__wrapper'>
                  <h3>Choose a game that suits you</h3>
                    <div className='page-work__buttons-wrapper'>
                      <button onClick={() => this.scrollToChild(1)} className='page-work__button'>
                          {intl.formatMessage({id: 'section.work.game-wow'})}
                      </button>
                      <button onClick={() => this.scrollToChild(2)} className='page-work__button'>
                          {intl.formatMessage({id: 'section.work.game-diablo'})}
                      </button>
                      <button onClick={() => this.scrollToChild(3)} className='page-work__button'>
                          {intl.formatMessage({id: 'section.work.game-wow-2'})}
                      </button>
                      <button onClick={() => this.scrollToChild(0)} className='page-work__button'>
                          {intl.formatMessage({id: 'section.work.game-other'})}
                      </button>
                    </div>
                </div>
                <h3 className='page-work__subheader'>{intl.formatMessage({id: 'section.work.more-header'})}</h3>
                {textData.map((item, index) =>
                  <WorkWithUsItem
                    forwardedRef ={this.childRefs[index]}
                    text={item.text}
                    header={item.header}
                    img={item.img}
                    hiring={item.hiring}/>)}

                <div className='page-work__wrapper'>
                    <h3>{intl.formatMessage({id: 'section.work.join-header'})}</h3>
                    <p className='feature-text__content'>{intl.formatMessage({id: 'section.work.require-text'})}</p>
                    <div className='page-work__wrapper-bottom'>
                        <p className='page-work__bottom-text'>{intl.formatMessage({id: 'section.work.fill-text'})}</p>
                        <div className='page-work__divider'></div>
                        <p className='page-work__bottom-text'>{intl.formatMessage({id: 'section.work.follow-text'})}</p>
                    </div>
                </div>
            </div>
          </React.Fragment>
        );
    }
};



// WEBPACK FOOTER //
// ./containers/workWithUsPage/WorkWithUsPage.js